export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUSES = [
  "Completed",
  "In Progress",
  "Finalise",
  "Long overdue",
  "Haven't start",
];

export const STATUS_STYLE = {
  Completed: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]",
  "In Progress": "bg-[#EFF6FF] text-[#1E40AF] border-[#BFDBFE]",
  Finalise: "bg-[#FAF5FF] text-[#6B21A8] border-[#E9D5FF]",
  "Long overdue": "bg-[#FEF2F2] text-[#991B1B] border-[#FECACA]",
  "Haven't start": "bg-[#F4F4F5] text-[#3F3F46] border-[#E4E4E7]",
};

export const PHASES = [
  {
    key: "account",
    label: "Accounting",
    fields: [
      ["preparation", "Key in"],
      ["review1", "1st review"],
      ["finalise", "Finalise"],
      ["submit_for_audit", "Submit to audit"],
    ],
  },
  {
    key: "audit",
    label: "Audit",
    fields: [
      ["in_progress", "Audit in progress"],
      ["review1", "1st review"],
      ["review2", "2nd review"],
      ["submit_to_auditor", "Submit to auditor"],
      ["report_issued", "Issued Audit report"],
    ],
  },
  {
    key: "tax",
    label: "Taxation",
    fields: [
      ["computation", "Tax Computation"],
      ["review1", "1st review"],
      ["finalise", "Finalise"],
      ["submit_to_lhdn", "Submit LHDN"],
    ],
  },
];

// Final stage of each department — reaching it means the department is done.
export const FINAL_STAGE = {
  account: "Submit to audit",
  audit: "Issued Audit report",
  tax: "Submit LHDN",
};

export const stageStyle = (phaseKey, stage, overdue) => {
  if (stage === "n/a") return "bg-zinc-50 text-zinc-400 border-zinc-200";
  if (overdue) return STATUS_STYLE["Long overdue"];
  if (stage === "Haven't start") return STATUS_STYLE["Haven't start"];
  if (stage === FINAL_STAGE[phaseKey]) return STATUS_STYLE.Completed;
  if (stage === "Finalise") return STATUS_STYLE.Finalise;
  return STATUS_STYLE["In Progress"];
};

export const emptyEngagement = () => ({
  client: "",
  year_end: "",
  notes: "",
  status_override: "",
  services: { account: true, audit: true, tax: true },
  account: { pic: "", preparation: "", review1: "", finalise: "", submit_for_audit: "" },
  audit: { pic: "", in_progress: "", review1: "", review2: "", submit_to_auditor: "", report_issued: "" },
  tax: { pic: "", computation: "", review1: "", finalise: "", submit_to_lhdn: "" },
});

export const fmt = (v) => {
  if (!v) return "";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return v;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" });
};
